import { inject, provideAppInitializer } from '@angular/core';

import { ChunkLoadRecoveryService } from '@app/core/services/chunk-load-recovery.service';

export const CHUNK_LOAD_RECOVERY_INIT_PROVIDER = provideAppInitializer(() =>
  inject(ChunkLoadRecoveryService).start(),
);
